import { EventBusKey } from "@vueuse/core";

export const dialogKey: EventBusKey<DialogMessage> = Symbol()

export interface DialogMessage {
    title: string;
    message: string;
    yes: string;
    no?: string;
    // eslint-disable-next-line
    callback?: Function;
    type: DialogType;
    disableOverlayClick?: boolean;
    confirmation?: string;
}

export enum DialogType {
    Danger = "danger",
    Info = "info",
    Redirect = "redirect",
    Warning = "warning"
}